import React from "react";
import { cn } from "../ui";

interface ShareCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  tone: "mail" | "whatsapp";
  onClick: () => void;
  /** Realce depois de aprovar o pedido (próximo passo sugerido). */
  highlight?: boolean;
}

/** Cartão de compartilhamento (e-mail, WhatsApp). */
export const ShareCard: React.FC<ShareCardProps> = ({ icon, title, description, tone, onClick, highlight }) => (
  <button
    type="button"
    onClick={onClick}
    className={cn(
      "flex min-h-16 items-center gap-3 rounded-card border bg-surface p-3.5 text-left transition duration-fast hover:-translate-y-px hover:border-primary focus-visible:outline-none focus-visible:shadow-focus",
      highlight ? "border-primary-line shadow-focus" : "border-line shadow-card"
    )}
  >
    <span
      className={cn(
        "grid h-card-icon w-card-icon shrink-0 place-items-center rounded-full",
        tone === "mail" ? "bg-primary-soft text-primary" : "bg-whatsapp-soft text-whatsapp"
      )}
      aria-hidden
    >
      {icon}
    </span>
    <span className="min-w-0">
      <strong className="block text-body font-semibold">{title}</strong>
      <span className="block text-caption text-fg-muted">{description}</span>
    </span>
  </button>
);
